import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
import Bot from './views/Bot';
import BotList from './views/BotList'
//import Admin from '@/views/Admin'; Currently using chatterbox-admin.html for this
import BotEditor from "./views/BotEditor";
import WorkBench from "./views/WorkBench";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/admin/:bot_name',
      name: 'BotEditor',
      component: BotEditor
    },
    {
      path: '/bots/:bot_name',
      name: 'Bot',
      component: Bot
    },
    {
      path: '/workbench/:component_path/:component_name',
      alias: '/WorkBench/:component_path/:component_name',
      name: 'workbench',
      component: WorkBench
    },
    {
      path: '/bots',
      alias: ['/','/Bots', '/BOTS'],
      name: 'BotList',
      component: BotList
    },
  ]
})
